import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import SoftBadge from 'components/common/SoftBadge';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import ModalNuevoNIT from './ModalNuevoNIT';
import ModalEditarNIT from './ModalEditarNIT';
import ModalAsignarDTE from './ModalAsignarDTE';


const PlanesFacturacionBolivia = () => {

    const columnsNITs = [
        {
            accessor: 'none',
            Header: '',
            Cell: rowData => {
                const { idBoliviaFacturacionExistencias } = rowData.row.original;
                return (
                    <>
                        <Row className="flex-start-center">
                            <Col xs="auto" >
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="border-300 text-600"
                                    onClick={() => handleEditarNIT(idBoliviaFacturacionExistencias)}
                                >
                                    <FontAwesomeIcon icon="edit" />
                                </Button>&nbsp;
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="border-300 text-600"
                                    onClick={() => handleAsignarDTE(idBoliviaFacturacionExistencias)}
                                >
                                    <FontAwesomeIcon icon="plus" />
                                </Button>
                            </Col>
                        </Row>
                    </>
                );
            }
        },
        {
            accessor: 'idBoliviaFacturacionExistencias',
            Header: 'ID',
            Cell: rowData => {
                const { idBoliviaFacturacionExistencias } = rowData.row.original;
                return (<span>{idBoliviaFacturacionExistencias}</span>)
            }
        },
        {
            accessor: 'bIsActive',
            Header: 'Estatus',
            headerProps: { className: 'pe-1' },
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { bIsActive } = rowData.row.original;
                return bIsActive ? (<SoftBadge pill bg='success' className='me-2'>Activo</SoftBadge>) : <><SoftBadge pill bg='danger' className='me-2'>No activo</SoftBadge></>;
            }
        },
        {
            accessor: 'vNombre',
            Header: 'Nombre',
            headerProps: { className: 'pe-1' },
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { vNombre } = rowData.row.original;
                return (<span >{vNombre}</span>);
            }
        },
        {
            accessor: 'vNIT',
            Header: 'NIT',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vNIT } = rowData.row.original;
                return (<span> {vNIT}</span>)
            }
        },
        {
            accessor: 'vUsuario',
            Header: 'Usuario',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vUsuario } = rowData.row.original;
                return (<span> {vUsuario}</span>)
            }
        },
        {
            accessor: 'vPassword',
            Header: 'Contrasena',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vPassword } = rowData.row.original;
                return (<span> {btoa(vPassword)}</span>)
            }
        },
        {
            accessor: 'iExistencia',
            Header: 'Existencia',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { iExistencia } = rowData.row.original;
                return (iExistencia < 0 ? <SoftBadge pill bg='success' className='me-2'>Ilimitado</SoftBadge> : <span> {(iExistencia == 0 ? <SoftBadge pill bg='danger' className='me-2'>Sin Existencia</SoftBadge> : iExistencia)}</span>)
            }
        },
        {
            accessor: 'dFechaExpiracion',
            Header: 'Fech. Expiraci\u00F3n',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const dFechaExpiracion = rowData.row.original.dFechaExpiracion;
                return (dFechaExpiracion == null) ? <SoftBadge pill bg='success' className='me-2' > Sin expiraci&oacute;n</SoftBadge > :
                    <span>

                        {
                            new Date(dFechaExpiracion).toLocaleDateString('es-MX', {
                                year: 'numeric', month: 'short', day: '2-digit'
                            })
                        }

                    </span>
            }
        }

    ];
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [NITs, setNITs] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [showNuevoNIT, setShowNuevoNIT] = useState(false);
    const [showEditarNIT, setShowEditarNIT] = useState(false);
    const [showModalAsignarDTE, setShowModalAsignarDTE] = useState(false);
    const [idNITSeleccionado, setIdNITSeleccionado] = useState(null);

    //Solicita los NITs para mostrar la tabla
    const ObtenerCatalogoNITs = async () => {
        setCargando(true);
        const response = await fetch("/api/PlanesFacturacionBolivia/ObtenerCatalogoNITs",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {
                const jsonNITs = JSON.parse(data.detalles);
                setNITs(jsonNITs);
            } else {
                showErrorToast(data.vMessage);
            }

            setCargando(false);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    useEffect(() => {
        ObtenerCatalogoNITs();
    }, []);

    const handleNuevoNIT = () => {
        setShowNuevoNIT(true);
    };

    const handleEditarNIT = (idNIT) => {
        setIdNITSeleccionado(idNIT);
        setShowEditarNIT(true);
    };

    const handleAsignarDTE = (idNIT) => {
        setIdNITSeleccionado(idNIT);
        setShowModalAsignarDTE(true);
    };

    const handleCloseNuevoNIT = () => {
        setShowNuevoNIT(false);
    };

    const handleCloseEditarNIT = () => {
        setShowEditarNIT(false);
        setIdNITSeleccionado(null);
    };

    const handleCloseAsignarDTE = () => {
        setShowModalAsignarDTE(false);
        setIdNITSeleccionado(null);
    };

    const handleSuccessNuevoNIT = () => {
        setShowNuevoNIT(false);
        showSuccessToast('NIT registrado exitosamente');
        ObtenerCatalogoNITs();
    };

    const handleSuccessEditarNIT = () => {
        setShowEditarNIT(false);
        setIdNITSeleccionado(null);
        showSuccessToast('NIT actualizado exitosamente');
        ObtenerCatalogoNITs();
    };

    const handleSuccessAsignarDTE = () => {
        setShowModalAsignarDTE(false);
        setIdNITSeleccionado(null);
        showSuccessToast('Plan asignado exitosamente');
        ObtenerCatalogoNITs();
    };

    return (
        <>
            <PageHeader
                title="Documentos Electr&oacute;nicos Fiscales Bolivia"
                image="/img/bandera-Bolivia.png"
                className="mb-1"
            >
            </PageHeader>

            <AdvanceTableWrapper
                columns={columnsNITs}
                data={NITs}
                sortable
                pagination
                perPage={15}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <Row className="flex-between-center">
                            <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
                                <div id="orders-actions">
                                    <IconButton
                                        onClick={handleNuevoNIT}
                                        variant="falcon-default"
                                        size="sm"
                                        icon="plus"
                                        transform="shrink-3">
                                        <span className="d-none d-sm-inline-block ms-1" >Nuevo NIT</span>
                                    </IconButton>
                                </div>
                            </Col>
                            <Col xs={6} sm="auto" className="ms-auto ps-0">
                                {!cargando &&
                                    <AdvanceTableSearchBox table />
                                }
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                hover: true,
                                className: 'fs--2 mb-0 overflow-hidden'
                            }}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter
                            rowCount={NITs.length}
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            {cargando && (<h3><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h3>)}

            <ModalNuevoNIT
                show={showNuevoNIT}
                onHide={handleCloseNuevoNIT}
                onSuccess={handleSuccessNuevoNIT}
            />

            <ModalEditarNIT
                show={showEditarNIT}
                onHide={handleCloseEditarNIT}
                onSuccess={handleSuccessEditarNIT}
                idNIT={idNITSeleccionado}
            />

            <ModalAsignarDTE
                show={showModalAsignarDTE}
                onHide={handleCloseAsignarDTE}
                onSuccess={handleSuccessAsignarDTE}
                idNIT={idNITSeleccionado}
            />
        </>
    );
};

export default PlanesFacturacionBolivia;
